import React from "react";
import { FiMessageSquare, FiX } from "react-icons/fi";

interface ChatWidgetButtonProps {
  isOpen: boolean;
  onToggle: () => void;
  unreadCount?: number;
}

export const ChatWidgetButton: React.FC<ChatWidgetButtonProps> = ({
  isOpen,
  onToggle,
  unreadCount = 0,
}) => {
  return (
    // `group` lives here on the wrapper — tooltip responds to hover on the
    // whole container, NOT inside the button (which rotates and would tilt the text)
    <div className=" fixed bottom-6 right-6 z-50 flex items-center gap-3 pointer-events-none">
      {/* Tooltip — sibling of button so it is NEVER rotated by the button transform */}


      {/* Button — rotation only affects THIS element and its children */}
      <button
        onClick={onToggle}
        aria-label={isOpen ? "Close AI Assistant" : "Open AI Assistant"}
        className={`relative pointer-events-auto group flex h-14 w-14 items-center justify-center rounded-full bg-brand-500 text-textPrimary shadow-xl transition-all duration-300 hover:scale-105 hover:bg-brand-500/80 active:bg-brand-500/70 focus:outline-none focus:ring-4 focus:ring-brand-200 dark:bg-brand-500 dark:hover:bg-brand-500/80 dark:active:bg-brand-500/70 dark:focus:ring-brand-900 ${isOpen ? "rotate-90" : "rotate-0"
          }`}
      >
    
        {/* Pulse ring — only when closed */}
        {!isOpen && (
          <span className="absolute -inset-1 animate-ping rounded-full bg-brand-400 opacity-30" />
        )}

        {/* Icon toggle */}
        {isOpen ? (
          <FiX className="h-6 w-6 transition-transform duration-200" />
        ) : (
          <FiMessageSquare className="h-6 w-6 transition-transform duration-200" />
        )}

        {/* Unread badge */}
        {!isOpen && unreadCount > 0 && (
          <span className="absolute -right-1 -top-1 flex h-5 w-5 animate-bounce items-center justify-center rounded-full bg-red-500 text-[11px] font-bold text-white shadow-sm">
            {unreadCount}
          </span>
        )}
      </button>
    </div>
  );
};
